import React from "react";
import { VideoTutorialSource } from "@/modules/commonMobile";

import "./index.scss";

interface IProps {
	pcode: string;
}

type IState = {
    show: boolean,
};

export default class VideoTutorial extends React.PureComponent<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = { show: true };
	}

    render() {
		const sourceVideo = VideoTutorialSource(
			this.props.pcode
		);

		return (
			<div>
			{
				sourceVideo && this.state.show ?
					<div className="video-tutorial-container">
						<video controls className='video-tutorial' autoPlay loop>
							<source src={sourceVideo} type="video/mp4" />
						</video> 

						<i className={"btn-close"}
							onClick={this.closeVideo} />
					</div>
					: null
			}
			</div>
		)
	}

	closeVideo = () => {
        this.setState(prevState => ({
            ...prevState,
            show: false
        }));
    }
}